import { create } from 'zustand';
import { useEffect } from 'react';

interface ToastItem {
  id: number;
  message: string;
  variant: 'success' | 'error' | 'info';
}

interface ToastState {
  items: ToastItem[];
  push: (message: string, variant?: ToastItem['variant']) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  items: [],
  push: (message, variant = 'info') => {
    const id = nextId++;
    set((s) => ({ items: [...s.items, { id, message, variant }] }));
    setTimeout(() => {
      set((s) => ({ items: s.items.filter((i) => i.id !== id) }));
    }, 3500);
  },
  dismiss: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
}));

export function toast(message: string, variant: ToastItem['variant'] = 'info'): void {
  useToastStore.getState().push(message, variant);
}

export function ToastViewport() {
  const items = useToastStore((s) => s.items);
  useEffect(() => undefined, []);
  return (
    <div className="fixed bottom-24 inset-x-0 z-50 flex flex-col items-center gap-2 px-4 pointer-events-none">
      {items.map((t) => (
        <div
          key={t.id}
          role="status"
          className="pointer-events-auto rounded-2xl px-4 py-3 text-sm shadow-card max-w-sm w-full text-center"
          style={{
            background:
              t.variant === 'success'
                ? '#fafafa'
                : t.variant === 'error'
                  ? 'rgba(194,58,46,0.95)'
                  : 'rgba(17,17,19,0.94)',
            color: t.variant === 'success' ? '#0a0a0b' : '#ffffff',
            border:
              t.variant === 'success'
                ? '1px solid rgba(255,255,255,0.85)'
                : '1px solid var(--line-2)',
            backdropFilter: 'blur(10px)',
          }}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
